module.exports = __webpack_public_path__ + "img/4everland.1db499b2.svg";